/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData, uploadSingleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";

const SavePromptPopup = ({
  afterPopupCLose = () => {},
  promptId,
  setPromptId,
}) => {
  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { t } = useTranslation(); //for translation
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [objective, setObjective] = useState("");
  const [leadowner, setLeadOwner] = useState("");
  const [engprompt, setEngprompt] = useState("");
  const [esprompt, setEsprompt] = useState("");
  const [botname, setBotName] = useState("");
  const [welcometext, setWelcomeText] = useState("");
  const [isFeatured, setIsFeatured] = useState(false);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadedPreviewImage, setUploadedPreviewImage] = useState("");
  const [uploadedImageId, setUploadedImageId] = useState(null);

  const [isSaving, setIsSaving] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [errors, setErrors] = useState({});

  const offcanvasBodyRef = useRef(null);

  console.log("UserInfo", userInfo);

  if(leadowner === "" && userInfo && userInfo.email){
    setLeadOwner(userInfo.email);
  }



  /* function to validate form */
  const validate = () => {
    const newErrors = {};

    if (title.trim() === "") {
      newErrors.title = t("Please enter a descriptive title for the prompt.");
    }
    
    if (slug.trim() === "") {
      newErrors.slug = t("A unique slug is required (e.g., my-new-prompt).");
    }

    if (botname.trim() === "") {
      newErrors.botname = t("Chat Bot Display Name is required.");
    }

    if (leadowner.trim() === "") {
      newErrors.leadowner = t("Lead Owner Email is required.");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(leadowner)) {
      newErrors.leadowner = t("Please enter a valid email address.");
    }

    if (welcometext.trim() === "") {
      newErrors.welcometext = t("Welcome Text is required.");
    }

    if (objective.trim() === "") {
      newErrors.objective = t("Prompt is required.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* function to generate slug from title */
  const generateSlugFromTitle = (titleText) => {
    return titleText
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '') // Remove special characters except hyphens and spaces
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
      .replace(/^-|-$/g, ''); // Remove leading and trailing hyphens
  };

  /* function to upload image */
  const imageUploadHandler = async (file) => {
    setIsUploading(true);
    setErrors((prev) => ({ ...prev, logo: "" }));
    try {
      const requestUrl =
        url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD;
      const response = await uploadSingleFile(requestUrl, file[0]);
      if (response.status) {
        setUploadedPreviewImage(response.data.path);
        setUploadedImageId(response.data._id);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsUploading(false);
      resetFile();
    }
  };

  /* function to reset file */
  const resetFile = () => {
    const file = document.getElementById("uploadLogoEcosystem");
    if (file) file.value = null;
  };

  /* function to get details */
  const getDetails = async () => {
    if (!promptId) return;
    setIsLoadingDetails(true);
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_DETAILS_GPTPROMPT +
        `/${promptId}`;

      const response = await getData(requestUrl);

      console.log("Response from getDetails:", response);

      if (response.status) {
        const { data } = response;
        setTitle(data.title || "");
        setSlug(data.slug || "");
        setObjective(data.objective || "");
        setLeadOwner(data.leadowner || "");
        setEngprompt(data.engprompt || "");
        setEsprompt(data.esprompt || "");
        setBotName(data.botname || "");
        setWelcomeText(data.welcometext || "");
        setIsFeatured(data.isfeatured || false);
        setUploadedImageId(data.logo ? data.logo._id : null);
        setUploadedPreviewImage(data.logo ? data.logo.path : "");
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoadingDetails(false);
    }
  };

  /* function to save prompt */
  const savePromptHandler = async () => {
    if (!validate()) {
      if (offcanvasBodyRef.current) {
        offcanvasBodyRef.current.scroll({
          top: 0,
          behavior: "smooth",
        });
      }
      return;
    }

    setIsSaving(true);
    try {
      let promptData = {
        title,
        slug,
        objective,
        leadowner,
        botname,
        logo: uploadedImageId,
        engprompt,
        esprompt,
        welcometext,
        isfeatured: isFeatured,
      };

      console.log("Prompt Data to be saved:", promptData);

      let requestUrl = url.API_BASE_URL;
      let response = {};

      if (promptId) {
        requestUrl += `${url.API_UPDATE_GPTPROMPTS}/${promptId}`;
        response = await putData(requestUrl, promptData);
      } else {
        requestUrl += `${url.API_CREATE_GPTPROMPTS}`;
        response = await postData(requestUrl, promptData);
      }
      console.log("Response from savePromptHandler:", response);
      
      if (response.status) {
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveGptPrompt")
        ).hide();
        resetHandler();
        afterPopupCLose([response.data]);
      }

    } catch (error) {
      console.log(error.message);
    } finally {
      setIsSaving(false);
    }
  };

  /* reset */
  const resetHandler = () => {
    setTitle("");
    setSlug("");
    setObjective("");
    setLeadOwner("");
    setEngprompt("");
    setEsprompt("");
    setBotName("");
    setWelcomeText("");
    setIsFeatured(false);
    setUploadedImageId(null);
    setUploadedPreviewImage("");
    setPromptId(null);
    setErrors({});
    setIsLoadingDetails(false);
    setIsSaving(false);
  };

  /* useEffect */
  useEffect(() => {
    if (promptId) {
      getDetails();
    } else {
      resetHandler();
    }
  }, [promptId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveGptPrompt"
      aria-labelledby="saveGptPromptLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              auto_awesome
            </span>{" "}
            {/* Using 'auto_awesome' icon as a placeholder */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {promptId ? t("Edit Prompt") : t("Create New Prompt")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {promptId
                ? t("Manage existing prompt details")
                : t("Define a new AI prompt")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div ref={offcanvasBodyRef} className="offcanvas-body p-4">
        {isLoadingDetails && (
          <div className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 z-index-1050">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">
                {t("Loading prompt details...")}
              </span>
            </div>
            <p className="text-primary mt-3 fw-bold">
              {t("Loading prompt details...")}
            </p>
          </div>
        )}
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              {/* Title */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="titleInput"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Title")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="titleInput"
                  className={`form-control fs-sm shadow-none ${
                    errors.title ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., Customer Support Bot")}
                  value={title}
                  onChange={(e) => {
                    const newTitle = e.target.value;
                    setTitle(newTitle);
                    
                    // Auto-generate slug if slug is empty
                    if (slug.trim() === "" && newTitle.trim() !== "") {
                      setSlug(generateSlugFromTitle(newTitle));
                    }
                    
                    if (errors.title) {
                      setErrors((prev) => ({ ...prev, title: "" }));
                    }
                  }}
                  aria-describedby="titleFeedback"
                />
                {errors.title && (
                  <div id="titleFeedback" className="invalid-feedback d-block">
                    {errors.title}
                  </div>
                )}
              </div>

              {/* Slug and Featured in same row */}
              <div className="row mb-4">
                <div className="col-md-6">
                  <div className="form-group p-3 border rounded-8 shadow-sm bg-white h-100">
                    <label
                      htmlFor="slugInput"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Slug")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="slugInput"
                      className={`form-control fs-sm shadow-none ${
                        errors.slug ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t("e.g., customer-support-bot")}
                      value={slug}
                      onChange={(e) => {
                        setSlug(e.target.value);
                        if (errors.slug) {
                          setErrors((prev) => ({ ...prev, slug: "" }));
                        }
                      }}
                      aria-describedby="slugFeedback"
                    />

                    {errors.slug ? (
                      <div id="slugFeedback" className="invalid-feedback d-block">
                        {errors.slug}
                      </div>
                    ) : (
                      <div className="form-text">
                        {t(
                          "The slug is used in the URL. Use lowercase letters, numbers, and hyphens."
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group p-3 border rounded-8 shadow-sm bg-white h-100 d-flex align-items-center">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="isFeaturedCheck"
                        checked={isFeatured}
                        onChange={(e) => setIsFeatured(e.target.checked)}
                      />
                      <label
                        className="form-check-label fs-sm fw-semibold text-dark ms-2"
                        htmlFor="isFeaturedCheck"
                      >
                        {t("Mark as Featured")}
                      </label>
                      <div className="form-text">
                        {t("Featured prompts will be highlighted in AI Chat frontend.")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              

              {/* Chat Bot name */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="chatbotNameInput"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Chat Bot Display Name")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="chatbotNameInput"
                  className={`form-control fs-sm shadow-none ${
                    errors.botname ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., HelperBot 2000")}
                  value={botname}
                  onChange={(e) => {
                    setBotName(e.target.value);
                    if (errors.botname) {
                      setErrors((prev) => ({ ...prev, botname: "" }));
                    }
                  }}
                  aria-describedby="botnameFeedback"
                />
                {errors.botname && (
                  <div id="botnameFeedback" className="invalid-feedback d-block">
                    {errors.botname}
                  </div>
                )}
              </div>

              {/* Lead Owner Email */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="leadownerInput"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Lead Owner Email")} <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  id="leadownerInput"
                  className={`form-control fs-sm shadow-none ${
                    errors.leadowner ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., sales-lead@yourcompany.com")}
                  value={leadowner}
                  onChange={(e) => {
                    setLeadOwner(e.target.value);
                    if (errors.leadowner) {
                      setErrors((prev) => ({ ...prev, leadowner: "" }));
                    }
                  }}
                  aria-describedby="leadownerFeedback"
                />
                {errors.leadowner && (
                  <div
                    id="leadownerFeedback"
                    className="invalid-feedback d-block"
                  >
                    {errors.leadowner}
                  </div>
                )}
              </div>

              {/* Welcome text */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="aiwelcometext"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Welcome Text")} <span className="text-danger">*</span>
                </label>
                <textarea
                  id="aiwelcometext"
                  rows="6"
                  className={`form-control fs-sm shadow-none ${
                    errors.welcometext ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t(
                    "Enter the initial greeting users will see when opening the chat."
                  )}
                  value={welcometext}
                  onChange={(e) => {
                    setWelcomeText(e.target.value);
                    if (errors.welcometext) {
                      setErrors((prev) => ({ ...prev, welcometext: "" }));
                    }
                  }}
                  aria-describedby="welcometextFeedback"
                ></textarea>
                {errors.welcometext && (
                  <div id="welcometextFeedback" className="invalid-feedback d-block">
                    {errors.welcometext}
                  </div>
                )}
              </div>

              {/* Objective */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="objectiveTextarea"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Prompt")} <span className="text-danger">*</span>
                </label>
                <textarea
                  id="objectiveTextarea"
                  rows="10"
                  className={`form-control fs-sm shadow-none ${
                    errors.objective ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t(
                    "Describe the main purpose and goal of this AI prompt."
                  )}
                  value={objective}
                  onChange={(e) => {
                    setObjective(e.target.value);
                    if (errors.objective) {
                      setErrors((prev) => ({ ...prev, objective: "" }));
                    }
                  }}
                  aria-describedby="objectiveFeedback"
                ></textarea>
                {errors.objective && (
                  <div
                    id="objectiveFeedback"
                    className="invalid-feedback d-block"
                  >
                    {errors.objective}
                  </div>
                )}
              </div>

              {/* AI Prompt (English) */}
              {/* <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="aiPromptTextarea"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("AI Prompt")}
                </label>
                <textarea
                  id="aiPromptTextarea"
                  rows="6"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t(
                    "Enter the detailed AI prompt. e.g., 'You are a helpful assistant for...'"
                  )}
                  value={engprompt}
                  onChange={(e) => setEngprompt(e.target.value)}
                ></textarea>
              </div> */}

              

              {/* File Upload */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="logoUpload"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Logo (can be used for chat bot)")}
                </label>

                <FileUploadField
                  label={t("Upload Logo")}
                  accept="jpg png jpeg gif"
                  onUpload={imageUploadHandler}
                  files={
                    uploadedPreviewImage === ""
                      ? [
                          {
                            path: "https://placehold.co/150x150",
                            name: "Logo",
                          },
                        ]
                      : [
                          {
                            path: url.SERVER_URL + uploadedPreviewImage,
                            name: "Logo",
                          },
                        ]
                  }
                  onRemove={() => {
                    setUploadedPreviewImage("");
                    setUploadedImageId(null);
                  }}
                  loading={isUploading}
                  fileType="image"
                />
              </div>
            </div>

            {/* Action Buttons */}
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={savePromptHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Prompt")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SavePromptPopup;
